
import React , { useState , useEffect } from 'react';

import './App.css';


import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';




import { BrowserRouter , Routes , Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
//import Login from './components/Login';
import Recarga from './components/Recarga';
//import UploadData from './components/UploadData';
import Login2 from './components/Login/Login/Login2';
import UploadData2 from './components/UploadData2';
import Search from './components/Search/Search';
import Indexado from './components/MoveTable/Indexado';
import Index2 from './components/MoveTable/Index2';
import Grouped from './Grouped/Grouped';

function App() {

  const [ data , setData ] = useState(null); // Los datos del loguel

  return (

    <>
    
    


    <BrowserRouter >
      <LandingPage data={data}/>

    
      <Routes>
        
        <Route path="/" element={<Login2 setData={(val) => setData( val )} />}></Route>
        <Route path="/recarga" element={<Recarga/>}></Route>
        <Route path="/upload" element={<UploadData2/>}></Route>
        <Route path="/move" element={<Indexado/>}></Route>
        <Route path="/moverep" element={<Index2 />}></Route>
        <Route path="/search" element={<Search/>}></Route>
        <Route path="/grouped" element={<Grouped/>}></Route>

      </Routes>
    </BrowserRouter>

    </>
  )

}

export default App;
